import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnpublish = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 7.99978,
		cy: 7.99978,
		r: 6.36111,
		stroke: "#EA1A0F",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("line", {
		x1: 3.19683,
		y1: 3.02533,
		x2: 12.9746,
		y2: 12.8031,
		stroke: "#EA1A0F",
		strokeWidth: 1.5
	})]
});
const ForwardRef = forwardRef(SvgUnpublish);
export default ForwardRef;
